import app from 'flarum/forum/app';
import { installCustomWelcomeHero } from './CustomWelcomeHero';
export { default as extend } from './extend';
app.initializers.add('choina-pomagam-parafialnie', () => {
  console.log('[choina/flarum-pomagam-parafialnie] Hello, forum!');
  installCustomWelcomeHero();
});